import type { ClarityDocumentUrlActivation } from './models/clarity-document-url-activation.model';

export function isClarityDocumentUrlInActiveDomain(
	activation: ClarityDocumentUrlActivation,
	activeDomainId: string | null,
): boolean {
	return activeDomainId !== null && activation.target.domainId === activeDomainId;
}
